import { useTranslation } from 'react-i18next';
import Typography from '@lib/components/Typography/Typography';
import Input from '@lib/components/Input/Input';
import copyTextToClipboard from '@lib/utils/copyTextToClipboard';
import styles from './SpConfigurationSection.module.scss';

const { VITE_API_URL } = import.meta.env;

interface Props {
  code?: string;
}

function getSpUrls(code: string) {
  const base = `${VITE_API_URL}/sso/saml/${code}`;
  return {
    entityId: base,
    acsUrl: `${base}/callback`,
    metadataUrl: `${base}/metadata`,
  };
}

export default function SpConfigurationSection({ code }: Props) {
  const { t } = useTranslation();
  const ssoCode = code || 'sso_xxx';
  const urls = getSpUrls(ssoCode);

  return (
    <div className={styles.root}>
      <Typography variant="h3">{t('sp-configuration')}</Typography>
      <div className={styles.fields}>
        <Input copyable disabled label={t('entity-id')} value={urls.entityId} />
        <Input copyable disabled label={t('acs-url')} value={urls.acsUrl} />
        <div className={styles.divider}>
          <span className={styles.dividerLine} />
          <Typography variant="caption" className={styles.dividerText}>
            {t('or')}
          </Typography>
          <span className={styles.dividerLine} />
        </div>
        <Input
          copyable
          disabled
          label={t('metadata-url')}
          value={urls.metadataUrl}
        />
      </div>
    </div>
  );
}
